import TYPES from './types';

const INITIAL_STATE = {
  graphs: {},
  loading: true
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.GET_LOG_REPORTS_GRAPH.SUCCESS:
      // Fusion has a bug when all values are 0. Thus we filter the request to keep data with at least one non-zero value
      const hasNonZeroValues = payload.data.data.dataset.map(item => ({
        seriesname: item.seriesname,
        data: item.data.every(i => i.value === 0) ? [] : item.data
      }));

      return {
        ...state,
        loading: false,
        graphs: {
          ...state.graphs,
          [payload.label]: {
            categories: payload.data.data.categories,
            dataset: hasNonZeroValues.filter(item => item.data.length)
          }
        }
      };
    default:
      return state;
  }
};

export default reducer;
